import "@fpsm/cxy-tokens/tokens.css?__remix_sideEffect__";

import HeaderDesktop from './components/HeaderDesktop';

export const HeaderV2 = () => <HeaderDesktop />;